export const handleDateChange = (handleChangeFunc, name, objectName, date) => {
    handleChangeFunc(name, date, objectName);
};

export const handleMultiSelectChange = (handleChangeFunc, name, objectName, $fieldEvent, selectedValues) => {
    handleChangeFunc(name, selectedValues, objectName);

    if($fieldEvent != null) {
        $fieldEvent('change', name);
    }
};

export const handleSelectChange = (handleChangeFunc, name, objectName, $fieldEvent, selectedValue, keepFullObject) => {
    console.log(name, selectedValue);
    let newValue = null;
    if(selectedValue != null) {
        if(keepFullObject) {
            newValue = selectedValue;
        } else {
            newValue = selectedValue.value || selectedValue.description;
        }
    }

    handleChangeFunc(name, newValue, objectName);

    if($fieldEvent != null) {
        $fieldEvent('change', name);
    }
};

export const handleTextChange = (handleChangeFunc, e, objectName) => {
    return handleChangeFunc(e.target.name, e.target.value, objectName);
};

export const handleCheckboxChange = (handleChangeFunc, e, objectName) => {
    return handleChangeFunc(e.target.name, e.target.checked === true, objectName);
};



// WEBPACK FOOTER //
// ./src/utils/handle-changes.js